module.exports = __webpack_public_path__ + "static/img/strong_32.07e082ea.png";